const removeAuthInfoFromOfflineDB = () => {
   const request = indexedDB.open('notifications');
   request.onupgradeneeded = (e) => {
      const db = e.target.result; // also available on request.result
      db.createObjectStore('auth', { keyPath: 'name' }); // stores are like tables in indexedDB
   }
   request.onerror = (e) => { console.log('Error on removing token from IDB - ', e.target.errorCode); }
   request.onsuccess = (e) => {
      const db = e.target.result; // also available on request.result
      const tx = db.transaction('auth', 'readwrite');
      const authStore = tx.objectStore('auth');
      const cursorRequest = authStore.openCursor();
      cursorRequest.onsuccess = e => {
         const cursor = e.target.result;
         if (cursor) {
            if (cursor.key === 'token') {
               authStore.delete('token');
            }
            cursor.continue();
         }
      }
   }
}

export default removeAuthInfoFromOfflineDB;